import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import {
  Box,
  Typography,
  Button,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import apiHelper from "../../../../util/ApiHelper";
import { toast } from "react-toastify";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

const useStylesAll = makeStyles((theme) => ({
  root: {
    margin: 0,
    marginBottom: 20,
    minWidth: "100%",
  },
  leftGrid: {
    maxHeight: 100,
  },
  last: {
    margin: 0,
  },
  topBar: {
    padding: 0,
  },
  pagination: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
  "&::placeholder": {
    color: "grey",
  },
}));

export default function LogoGroupForm({ disabled, ...props }) {
  const { history, fetchData } = props;
  const classes = useStylesAll();
  let { id } = useParams();

  const { control, handleSubmit, setValue } = useForm();
  const [parentList, setParentList] = React.useState([]);
  const [parent, setParent] = React.useState("");

  const formatRowToData = (row) => {
    return {
      nameEn: row.en,
      nameTc: row.tc,
      parentId: row.parentId,
    }
  }

  useEffect(() => {
    apiHelper.hkiff
      .listGroupParent()
      .then((response) => {
        // parent id should not equal to id
        if (id && id !== 0) {
          var list = response.data.filter(x => x.id !== id);
        } else {
          var list = response.data;
        }
        setParentList(Array.isArray(response.data) ? list : []);
      }).catch(function (error) {
        console.log(error);
      });
    if (id) {
      apiHelper.hkiff
        .getLogoGroupById(id)
        .then((response) => {
          console.log(response.data);
          setValue("en", response.data.nameEn);
          setValue("tc", response.data.nameTc);
          if (response.data.parentId != null) {
            setParent(response.data.parentId);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, []);

  const updateEvent = async (data) => {
    try {
      data.parentId = parent == "" ? null : parent;
      const result = await apiHelper.hkiff.updateLogoGroupById(
        id, formatRowToData(data)
      );
      console.log(result.data);
      toast.dark("Your changes is saved.");
      history.push("/hkiff/logos/logo-group");
    } catch (err) {
      console.log(err);
    }
  };

  const createEvent = async (data) => {
    try {
      data.parentId = parent == "" ? null : parent;
      const result = await apiHelper.hkiff.postLogoGroup(
        formatRowToData(data)
      );
      if (result.data.code === -4) {
        toast.error("Duplicated event code.");
      } else {
        toast.dark("Event created.");

        //clear all fields
        setValue("en", "");
        setValue("tc", "");
        fetchData();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = (data) => {
    const sendEvent = () => {
      if (id) {
        updateEvent(data);
      } else {
        createEvent(data);
      }
    };
    sendEvent();
  };

  const handleSelectChange = (e) => {
    setParent(e.target.value);
  };

  return (
    <>
      <Box fontWeight={900} fontSize={13} mb={2} width="100%">
        <Typography variant="p">{props.description}</Typography>
      </Box>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <Box width="100%">
            <Controller
              control={control}
              name="en"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (English)"
                    variant="outlined"
                    helperText="The name is how it appears on your site."
                    {...field}
                    fullWidth
                  />
                );
              }}
            />
            <Controller
              control={control}
              name="tc"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (Traditional Chinese)"
                    variant="outlined"
                    helperText="The name is how it appears on your site."
                    {...field}
                    fullWidth
                  />
                );
              }}
            />

            <FormControl fullWidth margin="dense" variant="outlined">
              <InputLabel id="demo-simple-select-outlined-label">
                Parent Group
                </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={parent}
                onChange={handleSelectChange}
                label="Bulk Actions"
                disabled={disabled}
              >
                <MenuItem value="">
                  <em>Parent</em>
                </MenuItem>
                {parentList && parentList.map(function (v, k) {
                  return (
                    <MenuItem value={v.id}>{v.nameEn}</MenuItem>
                  );
                })}
              </Select>
            </FormControl>

            <Box display="flex" alignItems="flex-end" alignContent="flex-end">
              {disabled || (
                <Box>
                  <Button
                    className={classes.last}
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit"
                  >
                    {props.submitBtnTxt}
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        </fieldset>
      </form>
    </>
  );
}
